<template>
    <div class="Form__group">
        <label class="Form__label">Saved Filters</label>
        <div class="FilterManager" @click.stop.self="toggle">
            <div class="FilterManager__currentFilter" @click.stop.self="toggle">
                <span :class="nameClasses" v-if="currentFilter">{{ currentFilter.name }}</span>
                <div class="FilterManager__new" v-else>
                    <input type="text"
                           :class="newNameClasses"
                           v-model.trim="newFilterName"
                           placeholder="Type Name and Press Enter to Save"
                           @keyup="showFilters = false"
                           @keyup.enter="saveFilter"
                    >

                    <a href="#"
                       class="FilterManager__new-control FilterManager__new-control--clear"
                       v-show="newFilterName != ''"
                       @click.prevent="clearNewFilterName"
                    >
                        <i class="fa fa-times" aria-hidden="true"></i>
                    </a>

                    <a href="#"
                       class="FilterManager__new-control FilterManager__new-control--save"
                       v-show="newFilterName != ''"
                       @click.prevent="saveFilter"
                    >
                        <i class="fa fa-check" aria-hidden="true"></i>
                    </a>
                </div>
            </div>
            <div class="FilterManager__filters" v-show="showFilters">
                <ul class="Utility__list-unstyled">
                    <li class="FilterManager__filter" v-for="filter in sortedFilters">
                        <ul>
                            <li>
                                <a href="#"
                                   class="FilterManager__filter-name"
                                   @click.prevent="setFilter(filter)"
                                >
                                    {{ filter.name }}
                                </a>
                            </li>
                            <li class="FilterManager__control FilterManager__control--delete">
                                <a href="#"@click.prevent="deleteFilter(filter.id)"></a>
                            </li>
                            <li :class="defaultFilterControlClasses(filter.id)">
                                <a href="#" @click.prevent="setAsDefault(filter.id)"></a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                initialised: false,
                lastLoadedFilterId: null,
                currentFilterId: null,
                showFilters: false,
                savedFilters: [],
                newFilterName: '',
                currentFilters: {},
                currentLoadedFilters: {},
            }
        },

        props: {
            currentSavedFilters: {
                required: true,
                type: Array,
            },

            vehicleType: {
                required: true,
                type: String
            },
        },

        mounted() {
            this.savedFilters = this.currentSavedFilters;

            window.addEventListener('click', () => {
                this.showFilters = false;
            });

            bus.$on('current-filters', (filters) => {
                this.setCurrentFilterId(filters);
                this.currentFilters = filters;
            });

            bus.$on('filters-updated', (filters) => {
                this.setLastLoadedFilterId(filters);
                this.currentLoadedFilters = _.cloneDeep(filters);
            });
        },

        computed: {
            currentFilter() {
                return _.find(this.savedFilters, (filter) => {
                    return filter.id == this.currentFilterId;
                });
            },

            sortedFilters() {
                return _.sortBy(this.savedFilters, ['name']);
            },

            defaultFilter() {
                return _.find(this.savedFilters, (filter) => {
                    return filter.is_default == 1;
                });
            },

            nameClasses() {
                return {
                    'FilterManager__name': true,
                    'FilterManager__name--greyed-out': this.lastLoadedFilterId != this.currentFilterId,
                }
            },

            newNameClasses() {
                return {
                    'FilterManager__new-name': true,
                    'FilterManager__new-name--typing': this.newFilterName != '',
                }
            }
        },

        methods: {
            /**
             * Toggle whether the saved filter list is displayed
             */
            toggle() {
                if (this.newFilterName == '') {
                    this.showFilters = ! this.showFilters;
                }
            },

            /**
             * Set the given saved filter and apply
             * @param filter
             */
            setFilter(filter) {
                this.currentFilterId = filter.id;
                bus.$emit('load-filter', filter.settings);
                this.showFilters = false;
            },

            /**
             * Filter control classes
             * @param id
             * @return {{FilterManager__control: boolean, FilterManager__control--default: boolean, FilterManager__control--is-default: (computed.defaultFilter|defaultFilter|boolean)}}
             */
            defaultFilterControlClasses(id) {
                return {
                    'FilterManager__control': true,
                    'FilterManager__control--default': true,
                    'FilterManager__control--is-default': this.defaultFilter && id == this.defaultFilter.id,
                }
            },

            /**
             * Set the filter with the given id as the default
             * @param id
             */
            setAsDefault(id) {
                this.$http.post('/motorstats/filters/default', {
                    type: this.vehicleType,
                    id: id,
                }).then(() => {
                    let isCurrentDefault = this.defaultFilter && id == this.defaultFilter.id;

                    if (this.defaultFilter) {
                        this.defaultFilter.is_default = 0;
                    }

                    if (! isCurrentDefault) {
                        _.find(this.savedFilters, (filter) => {
                            return filter.id == id;
                        }).is_default = 1;
                    }
                })
            },

            /**
             * Delete the filter with the given id
             * @param id
             */
            deleteFilter(id) {
                this.$http.post('/motorstats/filters/delete', {
                    type: this.vehicleType,
                    id: id,
                }).then(() => {
                    this.savedFilters = _.reject(this.savedFilters, (filter) => {
                        return filter.id == id;
                    })
                })
            },

            /**
             * Set the current filter id
             * @param filters
             */
            setCurrentFilterId(filters) {
                let currentFilterMatch = _.find(this.savedFilters, (filter) => {
                    return _.isEqual(filter.settings, filters);
                });

                _.defer(() => {
                    this.currentFilterId = currentFilterMatch ? currentFilterMatch.id : null;

                    if (! this.initialised) {
                        this.initialised = true;

                        this.setLastLoadedFilterId(filters);
                        this.currentLoadedFilters = filters;
                    }
                })
            },

            /**
             * Set the current filter id
             * @param filters
             */
            setLastLoadedFilterId(filters) {
                let currentFilterMatch = _.find(this.savedFilters, (filter) => {
                    return _.isEqual(filter.settings, filters);
                });

                _.defer(() => {
                    this.lastLoadedFilterId = currentFilterMatch ? currentFilterMatch.id : null;
                })
            },

            /**
             * Clear the text for creating a new filter
             */
            clearNewFilterName() {
                this.newFilterName = '';
            },

            /**
             * Save a new filter with the current newFilterName
             */
            saveFilter() {
                if (this.newFilterName == '') return;

                this.$http.post('/motorstats/filters/save', {
                    type: this.vehicleType,
                    name: this.newFilterName,
                    filters: JSON.stringify(this.currentFilters),
                }).then((response) => {
                    this.savedFilters.push(response.data);
                    this.clearNewFilterName();

                    _.defer(() => {
                        this.setCurrentFilterId(this.currentFilters)
                        this.setLastLoadedFilterId(this.currentLoadedFilters);
                    });
                })
            }
        }
    }
</script>